export const CHECKIN = 'CHECKIN';
export const CHECKIN_ERROR = 'CHECKIN_ERROR';
export const LOADING_CHECKIN = 'LOADING_CHECKIN';
export const HAS_SHOPIFY = 'HAS_SHOPIFY';